<template>
  <div class="collage-photo-item" @mouseenter="showFavorite=true" @mouseleave="showFavorite=false">
    <div class="j-media"
         @click="onClick">
      <ImageItem :media="media" :is-paid="isPaid"/>
    </div>
    <CartActions :digital-item-id="digitalItemId"
                  :media="media"
                  :gallery="gallery"
                  v-if="cartEnabled"/>
    <transition name="fade" v-if="favoriteEnabled">
      <ToggleFavorite :icon-width="22"
                      :media="media"
                      v-show="showFavorite || media.favorite"
                      @toggle="$emit('toggle-favorite', $event)"
      />
    </transition>
  </div>
</template>

<script>
import {observeMedia} from "@/utils/media";
import CartActions from "@/domain/galleries/medias/CartActions.vue";
import {mediaTypes} from "@/domain/galleries/constants";
import ImageItem from "@/domain/galleryTree/components/ImageItem.vue";
import ToggleFavorite from "@/domain/galleryTree/components/ToggleFavorite.vue";

export default {
  name: "MediaItem",
  components: {ToggleFavorite, ImageItem, CartActions},
  emits: ['select', 'toggle-favorite'],
  data() {
    return {
      loading: false,
      addedToCart: false,
      showFavorite: false
    }
  },
  props: {
    gallery: {
      type: Object,
      required: false
    },
    media: {
      type: [Object, Number],
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    favoriteEnabled: {
      type: Boolean,
      default: true
    },
    cartEnabled: {
      type: Boolean,
      default: false
    },
    isPaid: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.observeMedia('.j-media', this.media.id, this.media.media_type === mediaTypes.VIDEO)
  },
  methods: {
    observeMedia,
    onClick() {
      this.$emit('select', this.index)
    }
  }
}
</script>

